module.exports = __webpack_public_path__ + "static/media/29BDOS13.3dd040fd.jpg";